import {Class} from '../utils'
import icons from '../resources/icons'
//import DetailItemsRenderer from './DetailItemsRenderer'

export default Class(
  /** @lends AccordionDetailsLayout# */
  {
    gui: null,
    result: null,
    panels: null,
    activePanel: null,
    headerPanel: null,
    detailItemsRenderer: null,

    initialize: function (options) {
      //this.detailsView = options.detailsView;
      this.showDescriptionInMore = true;
      this.gui = null;
      this.panels = [];
      this.activePanel = null;
      this.headerPanel = null;
      this.lastActivePanelId = "";
      if (options.detailItemsRenderer) {
        this.detailItemsRenderer = options.detailItemsRenderer;
      }
    },

    setResultActionListeners: function (listeners) {
      if (this.detailItemsRenderer.setResultActionListeners) {
        this.detailItemsRenderer.setResultActionListeners(listeners);
      }
    },

    getUI: async function (result) {
      this.gui = null;
      this.result = result;
      if (typeof this.result.lastActivePanelId !== 'undefined') {
        this.lastActivePanelId = this.result.lastActivePanelId;
      } else {
        this.lastActivePanelId = "";
      }
      this.panels = [];
      this.activePanel = null;
      this.headerPanel = null;
      await this.buildUI();
      return this.gui;
    },

    //	forgetState: function(){
    //		//this.lastActivePanelId = ""; 
    //	},

    buildUI: async function () {

      let detailHandlerDefs = this.result.searcher.getdetailHandlerDefs(this.result);
      let hasMore = (this.getMoreDetailHandlerDef(detailHandlerDefs) !== null);
      let hasCustom = this.result.searcher.getCustomButtonDefs(this.result).length > 0;
      //Create a "more" def if one doesn't exist and result has custom buttons
      if (!hasMore && hasCustom) {
        detailHandlerDefs.push({
          "buttonText": "", "buttonImage": null, "handler": () => {
            //return Promise.resolve([{type: 'jquery-dom-object', object: jQuery("<div/>")}]);
            return [{type: 'jquery-dom-object', object: jQuery("<div/>")}];
          }, more: true
        });
      }

      if (detailHandlerDefs.length == 1) {
        this.gui = jQuery('<div class="ssDetailContent ssAccordionDetails" />');
        if (this.showDescriptionInMore && this.result.description && this.result.description !== "") {
          this.gui.append(this.detailItemsRenderer.formatArea({value: this.result.description, icon: icons.info}));
        }
        const spinner = jQuery("<img class='spinner' src='" + icons.spinner + "'/>");
        this.gui.append(spinner);

        //let items = await detailHandlerDefs[0].handler(this.result, this);
        //let jQueryObject = this.detailItemsRenderer.formatItems(items);
        //this.gui.append(jQueryObject);
        detailHandlerDefs[0].handler(this.result, this).then(
          items => {
            let jQueryObject = this.detailItemsRenderer.formatItems(items);
            spinner.replaceWith(jQueryObject);
          }
        ).catch(() => {
        });

        if (hasMore) {
          this.gui.append(this.getCustomButtons());
        }
        //old
        // detailHandlerDefs[0].handler(this.result, this).then((items)=>{
        //   if (this.showDescriptionInMore && this.result.description && this.result.description !== ""){
        //     this.gui.append(this.detailItemsRenderer.formatArea({value: this.result.description, icon: icons.info }));
        //   }
        //   let jQueryObject = this.detailItemsRenderer.formatItems(items);
        //   this.gui.append(jQueryObject);
        //   if (hasMore){
        //     this.gui.append(this.getCustomButtons());
        //   }
        // });
      } else {
        this.gui = jQuery('<div id="ssAccordionDetails" class="ssAccordionDetails">');
        await this.createPanels(detailHandlerDefs);
      }
    },

    getCustomButtons: function () {
      const customButtonDefs = this.result.searcher.getCustomButtonDefs(this.result);
      let items = [];
      for (let i = 0; i < customButtonDefs.length; i++) {
        let buttonDef = customButtonDefs[i];

        //Create icon and text
        let icon = jQuery("<span/>");

        let buttonText = buttonDef.buttonText
        if (typeof buttonDef.getbuttonText !== 'undefined') {
          buttonText = buttonDef.getbuttonText(this.result);
        }

        if (buttonDef.buttonImage !== undefined) {
          icon = jQuery("<img title='" + buttonText + "' src = '" + buttonDef.buttonImage + "'/>");
        }
        let title = jQuery("<span>" + buttonText + "</span>");

        //Create click function
        let clickFunction;
        if (buttonDef.callBack) {
          clickFunction = async () => {
            let newButtonDef = await buttonDef.callBack(this.result);
            if (typeof newButtonDef !== 'undefined' && newButtonDef !== null) {
              title.empty();
              title.append(newButtonDef.buttonText);
              if (buttonDef.buttonImage !== undefined) {
                icon.attr("src", newButtonDef.buttonImage);
                icon.attr("title", newButtonDef.buttonText);
              }
            }
            return false;
          };
        }

        //Attach click function to icon and text
        if (buttonDef.callBack) {
          title.click(clickFunction);
          title.css("cursor", "pointer");
          if (buttonDef.buttonImage !== undefined) {
            icon.click(clickFunction);
            icon.css("cursor", "pointer");
          }
        }

        items.push({type: "button", icon: icon, title: title});
      }
      return this.detailItemsRenderer.formatItems(items);
    },

    destroyUI: function () {
      for (let i = 0; i < this.panels.length; i++) {
        let panel = this.panels[i];
        if (panel.content !== null) {
          panel.contentHolder.empty();
          panel.content.detach();
        }
        this.panels[i] = null;
      }
      this.gui.empty();
      this.gui = null;
      if (this.result !== null) {
        this.result.lastActivePanelId = this.lastActivePanelId;
      }
      this.result = null;
      this.panels = null;
    },

    createPanels: async function (detailHandlerDefs) {
      let panelToActivate = null;
      const moreDetailHandlerDef = this.getMoreDetailHandlerDef(detailHandlerDefs);
      //Create headerPanel first (more: true)
      if (moreDetailHandlerDef !== null) {
        let morePanel = this.createPanel(moreDetailHandlerDef);
        this.headerPanel = morePanel;
        this.panels.push(morePanel);
        panelToActivate = morePanel;
        morePanel.contentHolder.append(this.getCustomButtons());
      }
      const otherDetailHandlerDefs = this.getOtherDetailHandlerDefs(detailHandlerDefs);
      for (let i = 0; i < otherDetailHandlerDefs.length; i++) {
        let panel = this.createPanel(otherDetailHandlerDefs[i]);
        if (panelToActivate === null || panel.id === this.lastActivePanelId) {
          //panel.title.addClass("ssDefault");
          panelToActivate = panel;
        }
        this.panels.push(panel);
      }
      this.addPanelsToGui();
      this.activatePanel(panelToActivate);
    },

    getMoreDetailHandlerDef: function (detailHandlerDefs) {
      let moreFound = false;
      let moreDef = null;
      for (let i = 0; i < detailHandlerDefs.length; i++) {
        let detailHandlerDef = detailHandlerDefs[i];
        if (detailHandlerDef.more && !detailHandlerDef.fullScreen) {
          if (!moreFound) {
            moreFound = true;
            moreDef = detailHandlerDef;
            detailHandlerDef._renderAsMore = true;
          } else {
            detailHandlerDef._renderAsMore = false;
          }
        }
      }
      return moreDef;
    },

    getOtherDetailHandlerDefs: function (detailHandlerDefs) {
      const otherDetailHandlerDefs = [];
      for (let i = 0; i < detailHandlerDefs.length; i++) {
        let detailHandlerDef = detailHandlerDefs[i];
        //if ((typeof detailHandlerDef.more === 'undefined') || (detailHandlerDef.more === false)){
        if (!detailHandlerDef._renderAsMore) {
          otherDetailHandlerDefs.push(detailHandlerDef);
        }
      }
      return otherDetailHandlerDefs;
    },

    createPanel: function (detailHandlerDef) {

      const panel = {};
      panel.id = detailHandlerDef.buttonText;
      panel.gui = jQuery('<div class="ssDetailPanel"/>');
      if (detailHandlerDef._renderAsMore) {
        panel.title = jQuery('<div class="ssDetailTitle"></div>');
        panel.title.addClass("ssHeader");
        panel.title.append(jQuery('<div class="ssDetailTitleImage"><img title="' + this.result.title + '" src="' + this.result.image + '"></div>'));
        panel.title.append('<div class="ssDetailTitleText" >...</div>');
      } else {
        panel.title = jQuery('<div class="ssDetailTitle"></div>');
        let panelTopTitle = detailHandlerDef.buttonText;
        if (typeof detailHandlerDef.getbuttonText !== 'undefined') {
          panelTopTitle = detailHandlerDef.getbuttonText(this.result);
        }
        let panelTopImage = detailHandlerDef.buttonImage;
        if (typeof detailHandlerDef.getbuttonImage !== 'undefined') {
          panelTopImage = detailHandlerDef.getbuttonImage(this.result);
        }
        panel.title.append(jQuery('<div class="ssDetailTitleImage"><img  title="' + panelTopTitle + '" src="' + panelTopImage + '"></div>'));
        panel.title.append(jQuery('<div class="ssDetailTitleText">' + panelTopTitle + '</div>'));
      }
      panel.gui.append(panel.title);
      if (detailHandlerDef.fullScreen) {
        panel.contentHolder = jQuery('<div class="ssDetailContent full"/>');
      } else {
        panel.contentHolder = jQuery('<div class="ssDetailContent"/>');
      }
      const spinner = jQuery("<img class='spinner' src='" + icons.spinner + "'/>");
      panel.contentHolder.append(spinner);
      panel.gui.append(panel.contentHolder);
      panel.detailHandlerDef = detailHandlerDef;
      panel.content = null;
      return panel;
    },

    addPanelsToGui: function () {

      for (let i = 0; i < this.panels.length; i++) {
        let panel = this.panels[i];
        panel.title.click(() => {
          if (panel.gui.hasClass("ssActive")) {
            this.deActivatePanel(panel);
          } else {
            this.activatePanel(panel);
          }
        });
        this.gui.append(panel.gui);
      }
    },

    activatePanel: async function (panel) {
      if (panel !== null) {
        //Ensure it has content
        let handlerResult;
        if (panel.content === null) {
          handlerResult = panel.detailHandlerDef.handler(this.result, this);
        }
        //Hide an active panel
        //this.deActivatePanel(this.activePanel);
        this.hidePanel(this.activePanel);
        //Set to active and show
        this.activePanel = panel;
        this.lastActivePanelId = panel.id;
        this.showPanel(panel);
        if (panel.content === null) {
          let items = await handlerResult;
          let jQueryObject = this.detailItemsRenderer.formatItems(items);
          panel.content = jQueryObject;
          panel.contentHolder.find(".spinner").hide();
          panel.contentHolder.prepend(jQueryObject);
          if (this.showDescriptionInMore && panel.title.hasClass("ssHeader") && this.result.description && this.result.description !== "") {
            panel.contentHolder.prepend(this.detailItemsRenderer.formatArea({
              value: this.result.description,
              icon: icons.info
            }));
          }
        }
      }
    },

    deActivatePanel: function (panel) {
      if (panel !== null) {
        //Remove active and hide
        this.activePanel = null;
        this.hidePanel(panel);
        //If this is not the header panel -> activate the header panel
        if (!panel.title.hasClass("ssHeader")) {
          this.activatePanel(this.headerPanel);
        }
      }
    },

    showPanel: function (panel) {
      if (panel !== null) {
        if (panel.title.hasClass("ssHeader")) {
          //panel.title.slideUp('fast');
          //panel.title.hide();
        }
        panel.gui.addClass("ssActive");
        //panel.contentHolder.slideDown('fast');
        //panel.contentHolder.show();
      }
    },

    hidePanel: function (panel) {
      if (panel !== null) {
        if (panel.title.hasClass("ssHeader")) {
          //panel.title.slideDown('fast');
          //panel.title.show();
        }
        panel.gui.removeClass("ssActive");
        //panel.contentHolder.slideUp('fast');
        //panel.contentHolder.hide();
      }
    },

    CLASS_NAME: 'AccordionDetailsContent'

  });
